export default "__VITE_ASSET__Bk1xZcCu__"